import { Dimensions, Platform } from 'react-native';
const guidelineBaseWidth = 350;
const guidelineBaseHeight = 680;
const isSSR = Platform.OS === 'web' && typeof window === 'undefined';
export const scale = (size) => {
    if (isSSR)
        return size;
    const { width, height } = Dimensions.get('window');
    const shortDimension = Math.min(width, height);
    return shortDimension / guidelineBaseWidth * size;
};
export const verticalScale = (size) => {
    if (isSSR)
        return size;
    const { width, height } = Dimensions.get('window');
    const longDimension = Math.max(width, height);
    return longDimension / guidelineBaseHeight * size;
};
export const moderateScale = (size, factor = 0.5) => {
    if (isSSR)
        return size;
    return size + (scale(size) - size) * factor;
};
export const normalizeText = (size, factor = 0.25) => moderateScale(size, factor);
export const moderateVerticalScale = (size, factor = 0.5) => size + (verticalScale(size) - size) * factor;
export const s = scale;
export const vs = verticalScale;
export const ms = moderateScale;
export const mvs = moderateVerticalScale;
//# sourceMappingURL=scaling-utils.js.map